import Images from "../../utils/Images";

type CloseBtnProps = {
    onClick: (e:any) => void;
    width?: string;
    height?: string;
    right?: string;
    top?: string;
    color?: string;
};

export const CloseBtn = (props : CloseBtnProps): React.ReactElement => {
    const onClick = (e:any): void => {
        e.stopPropagation();
        props.onClick(e);
    };

    return <img style={{position:"absolute", top:props.top || "0.13rem", right: props.right || "0.13rem", width:props.width || "0.14rem", height:props.height || "0.14rem", flex:"none", cursor:"pointer"}}
        src={Images.iconClose} onClick={onClick} color={props.color || "var(--home-tag-btn-txt-color)"}></img>
};